import React from 'react';
import { Box, MenuItem, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import dayjs from 'dayjs';
import { formatRelativeTime } from '@helpers/formatRelativeTimeHelper';
import { NotificationAvatar } from '@notifications/components/NotificationAvatar';
import { NotificationMessage } from '@notifications/components/NotificationMessage';
import { getNotificationBody } from '@notifications/registry';
import { INotificationMenuItem } from './interfaces';

export const NotificationMenuItem: React.FC<INotificationMenuItem> = ({
  notification,
  onClick,
}): JSX.Element => {
  const unread = notification.readAt === null;
  const body = getNotificationBody(notification);
  const relativeDate = formatRelativeTime(
    dayjs(),
    dayjs(notification.createdAt)
  );

  return (
    <MenuItem
      onClick={() => onClick(notification)}
      sx={{
        whiteSpace: 'normal',
        alignItems: 'flex-start',
        py: 1.25,
        backgroundColor: unread
          ? (theme) => alpha(theme.palette.primary.main, 0.1)
          : 'transparent',
        '&:hover': {
          backgroundColor: unread
            ? (theme) => alpha(theme.palette.primary.main, 0.16)
            : undefined,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1.5,
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        <NotificationAvatar notification={notification} />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="body2" fontWeight={400} color="text.primary">
            <NotificationMessage notification={notification} />
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {relativeDate}
          </Typography>
          {body && <Box sx={{ mt: 1 }}>{body}</Box>}
        </Box>
      </Box>
    </MenuItem>
  );
};
